module.exports = __webpack_public_path__ + "img/databas.1c6dccce.jpg";